import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { ToasterService } from '../modules/toaster/toaster.service';
import { ErrorService } from '../services/error.service';
import { ApiError, markApiErrorHandled } from '../transport/api-error';
import { decodeBlobApiError } from '../transport/blob-api-error';
import { SILENT_API_ERRORS } from '../transport/api-request-context';

export const serverErrorInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);
  const errorService = inject(ErrorService);
  const router = inject(Router);
  const toasterService = inject(ToasterService);

  return next(request).pipe(
    catchError((error: unknown) => decodeBlobApiError(error).pipe(switchMap((decoded) => {
      const apiError = errorService.normalize(decoded);

      if (apiError.status === 401) {
        authService.resetSession();
        void router.navigate(['/login']);

        return rethrowHandled(apiError);
      }

      if (apiError.status === 0 && !request.context.get(SILENT_API_ERRORS)) {
        toasterService.error(apiError.message);

        return rethrowHandled(apiError);
      }

      return throwError(() => apiError);
    }))),
  );
};

function rethrowHandled(error: ApiError): Observable<never> {
  return throwError(() => markApiErrorHandled(error));
}
